export default __webpack_public_path__ + "static/media/DAIF_Eco_Clean.3b313d88.jpg";